import { scopeBucket } from "./scope-key.js";

export function splitPreview(frames, { splitBy, pageOf, scopeOf, qtyOf } = {}) {
  const list = frames || [];

  let types = 0;
  let qty = 0;
  const pages = new Set();
  const scopes = new Set();

  for (const frame of list) {
    types += 1;
    qty += qtyOf ? qtyOf(frame) : 0;

    if (splitBy === "page") {
      pages.add(pageOf ? pageOf(frame) : "");
    } else if (splitBy === "scope") {
      scopes.add(scopeBucket(scopeOf ? scopeOf(frame) : "").key);
    }
  }

  let files = 1;
  if (splitBy === "page") files = pages.size;
  else if (splitBy === "scope") files = scopes.size;

  return { files, types, qty };
}
